var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"alt":"kab logo","width":"89","height":"61","src":require('@/assets/bn-w@2x.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }